const doc = [({"zh_cn":({"adminButtonHotel":({"backToHotelShow":"回酒店", "changeChannelManager":"更改站点控制器"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;